{{if style.topBar.model != 'hide'}}
<div class="file-detail-header"
     style="{{style.topBar.model == 'default' ? '': 'color:' + style.topBar.color}};
                {{style.topBar.model == 'default' ? '': 'background-color:' + style.topBar.color2}};
                "
>
    <a href="javascript:history.back(-1)">
    <span class="smarket icons-backleft"
          style="{{style.topBar.model == 'default' ? '': 'color:' + style.topBar.color}};"
    ></span>
    </a>
</div>
{{/if}}
<div class="sk-cms-article-detail-wap padd35 sk-cms-article-get"
    {{if style.background.styleType == 'custom'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
{{if style.titleStyle.model != 'hide'}}
    <div class="article-title {{style.titleStyle.model == 'default'?'medium':style.titleStyle.fontSize}}"
    style="{{style.titleStyle.model == 'default' ? '': 'color:' + style.titleStyle.color}};{{style.lineStyle.model == 'default' ? '': 'border-bottom-color:' + style.lineStyle.color}};{{style.lineStyle.model == 'default' ? '': 'border-bottom-style:' + style.lineStyle.line}};{{style.lineStyle.model == 'hide' ? 'border-bottom:none':''}};{{style.lineStyle.model === 'hide' ? 'padding-bottom:0' :''}};"
    sk-html="$data.title" cms-not-replace>
    {{content.title}}
    </div>
{{/if}}
{{if style.infoData.model != 'hide'}}
  <div class="article-data {{style.infoData.model == 'default'?'':style.infoData.fontSize2}}"
  style="{{style.infoData.model == 'default' ? '': 'color:' + style.infoData.color}};"
  >
    <span class="data-item">
        <span class="smarket icons-time"
        style="{{style.infoData.model == 'default' ? '': 'color:' + style.infoData.iconColor}};"
        ></span> <span
        sk-html="$data.time" cms-not-replace
      >{{content.time}}</span>
    </span>
    <span class="data-item">
        <span class="smarket icons-eye"
        style="{{style.infoData.model == 'default' ? '': 'color:' + style.infoData.iconColor}};"
        ></span> <span
        sk-html="$data.preview" cms-not-replace
        ></span>
    </span>
  </div>
{{/if}}

{{if style.textStyle.model != 'hide'}}
    <div class="article-content {{style.textStyle.model == 'default'?'medium':style.textStyle.fontSize}}"
    style="{{style.textStyle.model == 'default' ? '': 'color:' + style.textStyle.color}}"
    {{(isDesign || isPreview) ? 'sk-html=$data.body' : ''}} cms-not-replace>
    {{#content.body}}
    </div>
{{/if}}
{{if style.button.styleType !='hide'}}
    <div class="foot-button-wrap" style="{{style.btnBackground.styleType == 'default' ? '': 'background-color:' + style.btnBackground.color}};">
            <div id="btn-collect" class="foot-button {{style.button.styleType == 'default'?'medium':style.button.fontSize}}"
            style="{{style.button.styleType == 'default' ? '': 'color:' + style.button.color}};{{style.button.styleType == 'default' ? '': 'background-color:' + style.button.backgroundColor}};{{'background-image: url('+ style.button.imgUrl + ')'}};"
            {{isDesign ? '' : 'sk-event.click=handelCollect()'}}>收藏</div>
    </div>
{{/if}}
{{if !isPreview && !isDesign}}
  <div id="login_url" style="display: none">{{(content.originUrl?content.originUrl.wap:'')|raw}}</div>
{{/if}}
</div>
